import { Controller } from "stimulus";

// 二重送信防止用コントローラー
export default class extends Controller {
  connect() {
    // フォームの送信ボタンが押下されたときのイベントリスナーを追加
    this.element.addEventListener('submit', () => {
      // 押下された送信ボタンを取得
      const btn = this.element.querySelector('button[type="submit"]')
      // 送信ボタンを無効化
      if (btn) btn.disabled = true
    });
  }
}